// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Popup$Showside from "./Popup.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as IconHeart$Showside from "../icons/IconHeart.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as NavbarItem$Showside from "./NavbarItem.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SwymitWishlist$Showside from "../utils/SwymitWishlist.bs.js";
import * as IconHeartFilled$Showside from "../icons/IconHeartFilled.bs.js";
import * as ProductListItem$Showside from "./ProductListItem.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as CustomerBrighton$Showside from "../customers/CustomerBrighton.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as CustomerBombayShirts$Showside from "../customers/CustomerBombayShirts.bs.js";
import * as ProductCardCTAButton$Showside from "./ProductCardCTAButton.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
function useFavorites(param) {
  var sourceLocalStorage = UserSavedProductsProvider$Showside.use(undefined).favorites;
  var sourceSwymit = SwymitWishlist$Showside.use(undefined);
  var match = sourceSwymit.supported;
  var match$1 = sourceLocalStorage.enabled;
  var source = match ? /* SourceSwymit */1 : match$1 ? /* SourceLocalStorage */0 : /* SourceNoop */2;
  switch (source) {
    case /* SourceLocalStorage */0:
      var count = sourceLocalStorage.count;
      var enabled = sourceLocalStorage.enabled;
      var handleAdd = function (product) {
        return Curry._1(sourceLocalStorage.add, {
          TAG: /* Product */0,
          _0: product
        });
      };
      var handleRemove = function (product) {
        return Curry._1(sourceLocalStorage.remove, {
          TAG: /* Product */0,
          _0: product
        });
      };
      var isAdded = function (product) {
        return Curry._1(sourceLocalStorage.isAdded, {
          TAG: /* Product */0,
          _0: product
        });
      };
      return {
        source: /* SourceLocalStorage */0,
        enabled: enabled,
        add: handleAdd,
        remove: handleRemove,
        isAdded: isAdded,
        count: count
      };
    case /* SourceSwymit */1:
      var count$1 = sourceSwymit.count;
      var enabled$1 = sourceSwymit.loaded;
      var handleAdd$1 = function (product) {
        return Curry._1(sourceSwymit.add, product.link);
      };
      var handleRemove$1 = function (product) {
        return Curry._1(sourceSwymit.remove, product.link);
      };
      var isAdded$1 = function (product) {
        return Curry._1(sourceSwymit.isAdded, product.firstVariant.id);
      };
      return {
        source: /* SourceSwymit */1,
        enabled: enabled$1,
        add: handleAdd$1,
        remove: handleRemove$1,
        isAdded: isAdded$1,
        count: count$1
      };
    case /* SourceNoop */2:
      var add = function (param) {
        return Promise.resolve(undefined);
      };
      var remove = function (param) {
        return Promise.resolve(undefined);
      };
      var isAdded$2 = function (param) {
        return Promise.resolve(false);
      };
      return {
        source: /* SourceNoop */2,
        enabled: false,
        add: add,
        remove: remove,
        isAdded: isAdded$2,
        count: 0
      };
  }
}
function useRecentlyAdded(param) {
  var match = UserSavedProductsProvider$Showside.use(undefined).favorites;
  var enabled = match.enabled;
  var value = match.value;
  var previous = Previous$Showside.usePreviousDistinct(value);
  var newAddedValue = React.useMemo(function () {
    if (!enabled) {
      return;
    }
    var hasAdded = value.length > previous.length;
    return Belt_Option.flatMap(Belt_Array.get(value, 0), function (value) {
      if (value.TAG === /* Product */0 && hasAdded) {
        return value._0;
      }
    });
  }, [value.length, previous.length]);
  var match$1 = React.useState(function () {
    return newAddedValue;
  });
  var setNewAdded = match$1[1];
  React.useEffect(function () {
    if (!enabled) {
      return;
    }
    Curry._1(setNewAdded, function (param) {
      return newAddedValue;
    });
    var timeoutId = setTimeout(function (param) {
      Curry._1(setNewAdded, function (param) {});
    }, 4000);
    return function (param) {
      clearTimeout(timeoutId);
    };
  }, [newAddedValue]);
  return [match$1[0], setNewAdded];
}
function useFavoritesLink(param) {
  var bombayshirts = CustomerBombayShirts$Showside.useWishlistLink(undefined);
  var brighton = CustomerBrighton$Showside.useWishlistLink(undefined);
  return Belt_Option.orElse(bombayshirts, brighton);
}
function Favorites$RecentlyAddedPopup(Props) {
  var position = Props.position;
  var match = EntrypointContext$Showside.use(undefined);
  var onFavoritesClick = match.onFavoritesClick;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$1.goTo;
  var route = match$1.route;
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var match$3 = match$2.config.settings;
  var pdpCTAButtonTextColor = match$3.pdpCTAButtonTextColor;
  var pdpCTAButtonBgColor = match$3.pdpCTAButtonBgColor;
  var match$4 = useRecentlyAdded(undefined);
  var setNewAdded = match$4[1];
  var newAdded = match$4[0];
  var renderHeader = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("flex")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("text-xl font-semibold flex-grow")
    }, "Saved to favorites!"), React.createElement("div", {
      className: CSS$Showside.prefix("flex-shrink-0")
    }, React.createElement(IconButton$Showside.make, {
      onClick: function (param) {
        Curry._1(setNewAdded, function (param) {});
      },
      size: /* Normal */2,
      iconSize: /* Small */3,
      icon: React.createElement(Unicons$Showside.UilTimes.make, {}),
      dataTestId: "favorites-close-button",
      className: CSS$Showside.prefix("-mt-4 -mr-4")
    })));
  };
  var renderProductCard = function (product) {
    return React.createElement(ProductListItem$Showside.make, {
      product: product,
      shape: /* Square */1,
      imageFitStrategy: /* Cover */1,
      padding: false,
      onClick: function (param, param$1) {
        var pdpRoute;
        var exit = 0;
        if (typeof route === "number") {
          exit = 1;
        } else {
          switch (route.TAG | 0) {
            case /* Home */0:
              exit = 1;
              break;
            case /* ListPage */1:
              var listPageType = route._0.listPageType;
              var exit$1 = 0;
              if (typeof listPageType === "number" || listPageType.TAG !== /* Category */0) {
                exit$1 = 2;
              } else {
                var categoryId = listPageType._0;
                pdpRoute = {
                  TAG: /* PDP */2,
                  _0: {
                    categoryId: categoryId,
                    productCategoryId: categoryId,
                    productId: product.id,
                    variantId: undefined,
                    zoomedPhotoIndex: undefined
                  }
                };
              }
              if (exit$1 === 2) {
                pdpRoute = {
                  TAG: /* PDP */2,
                  _0: {
                    categoryId: undefined,
                    productCategoryId: undefined,
                    productId: product.id,
                    variantId: undefined,
                    zoomedPhotoIndex: undefined
                  }
                };
              }
              break;
            case /* PDP */2:
            case /* QuickView */3:
              pdpRoute = route;
              break;
          }
        }
        if (exit === 1) {
          pdpRoute = {
            TAG: /* PDP */2,
            _0: {
              categoryId: undefined,
              productCategoryId: undefined,
              productId: product.id,
              variantId: undefined,
              zoomedPhotoIndex: undefined
            }
          };
        }
        Curry._3(goTo, undefined, undefined, pdpRoute);
      }
    });
  };
  var renderFooter = function (param) {
    return React.createElement(ProductCardCTAButton$Showside.make, {
      size: /* Md */2,
      label: "View all Favorites",
      style: {
        backgroundColor: pdpCTAButtonBgColor,
        color: pdpCTAButtonTextColor
      },
      onClick: function (param) {
        Curry._1(setNewAdded, function (param) {});
        Curry._1(onFavoritesClick, undefined);
      },
      primary: true,
      dataTestId: "favorites-see-all-button"
    });
  };
  return React.createElement(Popup$Showside.make, {
    position: position,
    show: Belt_Option.isSome(newAdded),
    className: CSS$Showside.prefix("p-8"),
    dataTestId: "favorites-popup",
    children: null
  }, renderHeader(undefined), newAdded !== undefined ? renderProductCard(newAdded) : null, renderFooter(undefined));
}
Favorites$RecentlyAddedPopup.displayName = "Favorites.RecentlyAddedPopup";
var RecentlyAddedPopup = {
  make: Favorites$RecentlyAddedPopup
};
function Favorites$ToggleButton(Props) {
  var product = Props.product;
  var atOpt = Props.at;
  var tabIndex = Props.tabIndex;
  var at = atOpt !== undefined ? atOpt : /* ProductCard */0;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = useFavorites(undefined);
  var isAdded = match$1.isAdded;
  var remove = match$1.remove;
  var add = match$1.add;
  var match$2 = React.useState(function () {
    return false;
  });
  var setSelected = match$2[1];
  var selected = match$2[0];
  React.useEffect(function () {
    Curry._1(isAdded, product).then(function (isAdded) {
      Curry._1(setSelected, function (param) {
        return isAdded;
      });
    });
  }, [product.id, match$1.count]);
  var handleClickAsync = React.useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (selected) {
      return Curry._1(remove, product).then(function (param) {
        Curry._1(setSelected, function (param) {
          return false;
        });
      });
    } else {
      return Curry._1(add, product).then(function (param) {
        Curry._1(setSelected, function (param) {
          return true;
        });
      });
    }
  }, [selected, product.id]);
  if (!match$1.enabled) {
    return null;
  }
  var tmp;
  switch (at) {
    case /* ProductCard */0:
      tmp = /* Small */3;
      break;
    case /* PDP */1:
      tmp = /* Large */1;
      break;
    case /* PDPSticky */2:
      tmp = /* Largest */0;
      break;
  }
  var tmp$1 = {
    onClickAsync: handleClickAsync,
    clear: isMobile,
    rounded: at === /* ProductCard */0,
    relative: false,
    size: tmp,
    iconSize: isMobile ? /* Smallest */4 : /* Small */3,
    icon: selected ? React.createElement(IconHeartFilled$Showside.make, {}) : React.createElement(IconHeart$Showside.make, {}),
    title: selected ? "Remove from favorites" : "Add to favorites",
    dataTestId: "favorites-toggle-button",
    iconClassName: CSS$Showside.prefix("-mb-0.5"),
    className: CSS$Showside.prefix(at !== 0 ? "border border-primary" : isMobile ? "" : "absolute top-4 right-4")
  };
  if (tabIndex !== undefined) {
    tmp$1.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  return React.createElement(IconButton$Showside.make, tmp$1);
}
Favorites$ToggleButton.displayName = "Favorites.ToggleButton";
var ToggleButton = {
  make: Favorites$ToggleButton
};
function Favorites$OpenButton(Props) {
  var atOpt = Props.at;
  var at = atOpt !== undefined ? atOpt : /* Navbar */0;
  var match = EntrypointContext$Showside.use(undefined);
  var onFavoritesClick = match.onFavoritesClick;
  var match$1 = ViewportContext$Showside.use(undefined);
  var isMobile = match$1.isMobile;
  var match$2 = useFavorites(undefined);
  var partial_arg = 1;
  var partial_arg$1 = 99;
  var badge = Belt_Option.flatMap(Belt_Option.keep(match$2.count, function (i) {
    return i > 0;
  }), function (param) {
    return StringUtils$Showside.fromInt(partial_arg$1, partial_arg, param);
  });
  var tmp;
  if (at) {
    var tmp$1 = {
      onClick: function (param) {
        Curry._1(onFavoritesClick, undefined);
      },
      shadow: true,
      icon: React.createElement(IconHeart$Showside.make, {}),
      title: "Favorites",
      dataTestId: "favorites-pdp-button",
      iconClassName: CSS$Showside.prefix("-mb-0.5"),
      className: CSS$Showside.prefix("mr-2 -top-px pointer-events-auto")
    };
    if (badge !== undefined) {
      tmp$1.badge = Caml_option.valFromOption(badge);
    }
    tmp = React.createElement(IconButton$Showside.make, tmp$1);
  } else {
    var tmp$2 = {
      label: "Favorites",
      children: React.createElement(IconHeart$Showside.make, {}),
      onClick: function (param) {
        Curry._1(onFavoritesClick, undefined);
      },
      pixelAdjustments: "-3px -3px -3px -3px",
      position: /* Fixed */1,
      dataTestId: "favorites-navbar-button"
    };
    if (badge !== undefined) {
      tmp$2.badge = Caml_option.valFromOption(badge);
    }
    tmp = React.createElement(NavbarItem$Showside.make, tmp$2);
  }
  return React.createElement(React.Fragment, undefined, tmp, React.createElement(Favorites$RecentlyAddedPopup, {
    position: at ? isMobile ? {
      top: {
        TAG: /* Ratio */1,
        _0: 1.2
      },
      left: {
        TAG: /* Px */0,
        _0: 10
      },
      bottom: /* Auto */0,
      right: {
        TAG: /* Px */0,
        _0: 10
      }
    } : {
      top: {
        TAG: /* Ratio */1,
        _0: 1.2
      },
      left: /* Auto */0,
      bottom: /* Auto */0,
      right: {
        TAG: /* Px */0,
        _0: 10
      }
    } : isMobile ? {
      top: /* Auto */0,
      left: {
        TAG: /* Px */0,
        _0: 10
      },
      bottom: {
        TAG: /* Ratio */1,
        _0: 1.1
      },
      right: {
        TAG: /* Px */0,
        _0: 10
      }
    } : {
      top: {
        TAG: /* Ratio */1,
        _0: 1.0
      },
      left: /* Auto */0,
      bottom: /* Auto */0,
      right: {
        TAG: /* Px */0,
        _0: 90
      }
    }
  }));
}
Favorites$OpenButton.displayName = "Favorites.OpenButton";
var OpenButton = {
  make: Favorites$OpenButton
};
export { useFavorites, useRecentlyAdded, useFavoritesLink, RecentlyAddedPopup, ToggleButton, OpenButton };
/* react Not a pure module */